import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { createElement } from "react";

const CartCtx = createContext(null);
const KEY = "guna-basket";

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const value = useMemo(() => {
    const add = (p) =>
      setItems((cur) => {
        const f = cur.find((i) => i.sku === p.sku);
        if (f) return cur.map((i) => (i.sku === p.sku ? { ...i, qty: i.qty + 1 } : i));
        return [...cur, { sku: p.sku, name: p.name, price: p.price, image: p.image, size: p.size, qty: 1 }];
      });
    const setQty = (sku, qty) =>
      setItems((cur) => (qty <= 0 ? cur.filter((i) => i.sku !== sku) : cur.map((i) => (i.sku === sku ? { ...i, qty } : i))));
    const clear = () => setItems([]);
    const count = items.reduce((a, i) => a + i.qty, 0);
    const total = items.reduce((a, i) => a + i.qty * i.price, 0);
    return { items, add, setQty, clear, count, total, open, setOpen };
  }, [items, open]);

  return createElement(CartCtx.Provider, { value }, children);
};

export const useCart = () => useContext(CartCtx);
